import React, { useState } from 'react';
import {
  Box, Heading, VStack, Text, IconButton, Collapse, Divider, HStack
} from '@chakra-ui/react';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqs = [
  {
    question: 'How does the free trial work?',
    answer:
      'Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  },
  {
    question: 'What features are included in the trial?',
    answer:
      'All major features are included in the trial so you can fully evaluate the product.',
  },
  {
    question: 'How long does the free trial last?',
    answer:
      'The free trial lasts for 14 days from the date of activation.',
  },
  {
    question: 'Can I cancel the trial at any time?',
    answer:
      'Yes, you can cancel the trial at any time from your account settings.',
  },
  {
    question: 'Are there any limitations during the trial?',
    answer:
      'There are no major limitations, but some premium features may be restricted.',
  },
];

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <Box py={{ base: 8, md: 12, lg: 16 }} px={{ base: 4, md: 6, lg: 8 }}>
      <Heading 
        as="h2" 
        fontSize={{ base: 'lg', sm: 'xl', md: '2xl', lg: '3xl' }} 
        textAlign="center" 
        mb={{ base: 6, md: 8, lg: 10 }} 
        color="#244034" 
        fontWeight="bold"
        px={{ base: 2, md: 0 }}
      >
        Question & Answers
      </Heading>
      <Box
        maxW={{ base: "100%", md: "900px" }}
        mx="auto"
        bg="#EDF4F1"
        borderRadius={{ base: "xl", md: "2xl" }}
        p={{ base: 4, sm: 6, md: 8, lg: 10 }}
        boxShadow="sm"
      >
        <VStack spacing={{ base: 2, md: 4 }} align="stretch">
          {faqs.map((faq, idx) => (
            <Box key={faq.question}>
              <HStack 
                justify="space-between" 
                align="flex-start" 
                py={{ base: 3, sm: 4, md: 5 }}
                px={{ base: 2, md: 0 }}
                spacing={{ base: 2, md: 4 }}
              >
                <Box flex="1" pr={{ base: 2, md: 4 }}>
                  <Text 
                    fontWeight="bold" 
                    fontSize={{ base: 'sm', sm: 'md', md: 'lg' }} 
                    color="#222"
                    lineHeight="1.4"
                  >
                    {faq.question}
                  </Text>
                  <Collapse in={openIdx === idx} animateOpacity>
                    <Text 
                      color="gray.600" 
                      fontSize={{ base: 'xs', sm: 'sm', md: 'md' }} 
                      mt={{ base: 2, md: 3 }}
                      lineHeight="1.5"
                      pr={{ base: 2, md: 4 }}
                    >
                      {faq.answer}
                    </Text>
                  </Collapse>
                </Box>
                <IconButton
                  aria-label={openIdx === idx ? 'Close' : 'Open'}
                  icon={openIdx === idx ? <FaMinus /> : <FaPlus />}
                  onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
                  bg={openIdx === idx ? 'gray.200' : '#215560'}
                  color={openIdx === idx ? 'gray.500' : 'white'}
                  fontSize={{ base: "12px", md: "14px" }}
                  borderRadius="50%"
                  minW={{ base: "28px", sm: "30px", md: "32px" }}
                  minH={{ base: "28px", sm: "30px", md: "32px" }}
                  w={{ base: "28px", sm: "30px", md: "32px" }}
                  h={{ base: "28px", sm: "30px", md: "32px" }}
                  _hover={{ 
                    bg: openIdx === idx ? 'gray.300' : '#17434a',
                    transform: 'scale(1.05)'
                  }}
                  transition="all 0.2s"
                  size="sm"
                  flexShrink={0}
                />
              </HStack>
              {idx !== faqs.length - 1 && (
                <Divider 
                  borderColor="#E2E8F0" 
                  mx={{ base: 2, md: 0 }}
                />
              )}
            </Box>
          ))}
        </VStack>
      </Box>
    </Box>
  );
};

export default FAQSection; 